import React, { useState } from 'react';
import s from '../../pages/PDV.module.css';

// Caixa (turno) aberto num dia anterior: a operadora esqueceu de fechar ontem.
// Se ela vender assim, o sistema fecha o turno antigo sozinho na 1ª venda —
// mas SEM a contagem do dinheiro, e a prestação de contas de ontem fica
// incompleta. Pedido da usuária (festolandiamix, 2026-11-04).
const dataBR = d => new Date(d).toLocaleDateString('en-CA', { timeZone: 'America/Sao_Paulo' }); // YYYY-MM-DD

export function caixaDeDiaAnterior(aberturaEm, agora = new Date()) {
  if (!aberturaEm) return false;
  return dataBR(aberturaEm) < dataBR(agora);
}

const CHAVE = id => `pdv_aviso_caixa_antigo_${id}`;
const dispensado = id => { try { return sessionStorage.getItem(CHAVE(id)) === '1'; } catch { return false; } };

export default function AvisoCaixaDiaAnterior({ turnoAtual, abrirFechamento, agora }) {
  const [, forcar] = useState(0);
  if (!turnoAtual || !caixaDeDiaAnterior(turnoAtual.abertura_em, agora) || dispensado(turnoAtual.id)) return null;

  const quando = new Date(turnoAtual.abertura_em).toLocaleString('pt-BR', {
    timeZone: 'America/Sao_Paulo', day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit',
  }).replace(',', ' às');
  const dispensar = () => {
    try { sessionStorage.setItem(CHAVE(turnoAtual.id), '1'); } catch { /* sem storage: só some até recarregar */ }
    forcar(n => n + 1);
  };

  return (
    <div className={s.modalOverlay}>
      <div onClick={e => e.stopPropagation()} style={{
        background: '#fff', borderRadius: 10, padding: 26, width: 440,
        boxShadow: '0 8px 40px rgba(0,0,0,0.35)', fontFamily: 'Tahoma, sans-serif',
      }}>
        <div style={{ fontSize: 16, fontWeight: 'bold', marginBottom: 14, color: '#b45309' }}>
          ⚠ Caixa aberto desde {quando}
        </div>
        <p style={{ margin: '0 0 10px', fontSize: 14, lineHeight: 1.5, color: '#333' }}>
          Seu caixa{turnoAtual.conta_nome ? ` (${turnoAtual.conta_nome})` : ''} foi aberto em outro dia e <strong>não foi fechado</strong>.
        </p>
        <p style={{ margin: '0 0 18px', fontSize: 14, lineHeight: 1.5, color: '#333' }}>
          Feche agora, informando o dinheiro contado, para a prestação de contas daquele dia ficar completa.
          Depois abra o caixa de hoje normalmente.
        </p>
        <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end' }}>
          <button onClick={dispensar} style={{
            padding: '8px 18px', fontSize: 14, cursor: 'pointer', border: '1px solid #ccc', borderRadius: 6, background: '#f5f5f5',
          }}>Agora não</button>
          <button onClick={abrirFechamento} autoFocus style={{
            padding: '8px 22px', fontSize: 14, fontWeight: 'bold', cursor: 'pointer', border: 'none', borderRadius: 6,
            background: '#b45309', color: '#fff',
          }}>Fechar caixa agora</button>
        </div>
      </div>
    </div>
  );
}
